import React, {  } from 'react';
import { Form, Input } from 'antd';




const { TextArea } = Input;

export default function PodatZayavlenieNaAnnulirovanieLitsenziiShkoliFederatsii(props) {
    const { object } = props;

    return (
        <Form
            form={props.form}
            onFinish={props.submit}
            labelAlign={"left"}
            layout={"vertical"}
            initialValues={{
                shkolaID: object.ID
            }}
        >
            <Form.Item
                preserve={"true"}
                hidden={true}
                name={"shkolaID"}
                label={"Школа"}
                rules={[{ required: true, message: 'Укажите школу!' }]}
            >
                <Input disabled />
            </Form.Item>
            <Form.Item
                name={"prichinaTekst"}
                label={"Причина"}
                rules={[{ required: true, message: 'Укажите причину!' }]}
            >
                <TextArea rows={4} />
            </Form.Item>
        </Form>
    );
}
